import { createDrawingObject, replaceLastPoint } from "../shared";
import { toOverlayPrimitive } from "../overlayPrimitiveAdapter";
import { hitTestOverlayPrimitive, renderOverlayPrimitiveToCanvas } from "@vninvestcharts/engine-core";
function renderIconMarker(ctx, drawing, scales, options) {
    const primitive = toOverlayPrimitive(drawing, scales, {
        chartWidth: options.chartWidth,
        chartHeight: options.chartHeight,
    });
    if (primitive) {
        renderOverlayPrimitiveToCanvas(ctx, primitive, options);
    }
}
function hitTestIconMarker(drawing, point, scales, tolerance) {
    const primitive = toOverlayPrimitive(drawing, scales);
    if (!primitive)
        return false;
    return hitTestOverlayPrimitive(primitive, point.pixelX, point.pixelY, { tolerance, chartWidth: 800, chartHeight: 600 });
}
const IconMarker = {
    name: "iconMarker",
    createDraft: (startPoint) => createDrawingObject("iconMarker", [startPoint], {
        style: { stroke: "#000000", strokeWidth: 2 },
    }),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
    hitTest: hitTestIconMarker,
};
export default IconMarker;
